import React from 'react';

const SvgSr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SR_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SR_svg__b" fill="#fff">
        <use xlinkHref="#SR_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#43924C"
        mask="url(#SR_svg__b)"
        d="M0 0h28v4H0zM0 16h28v4H0z"
      />
      <path fill="#CD153A" mask="url(#SR_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path
        fill="#F5D24B"
        mask="url(#SR_svg__b)"
        d="M14 11.7l-1.96 1.33.66-2.274-1.87-1.453 2.367-.075L14 7l.803 2.228 2.367.075-1.87 1.453.66 2.274z"
      />
    </g>
  </svg>
);

export default SvgSr;
